import { Directive } from 'vue';

const integerDirective: Directive = {
  bind(el: HTMLInputElement) {
    el.addEventListener('input', (e: Event) => {
      const input = e.target as HTMLInputElement;
      let value = input.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

      // Conversão para número e formatação
      value = parseInt(value) > 0 ? parseInt(value).toString(): "0";


      input.value = value;
    });
  }
};

export default integerDirective;